import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { ServicingSection } from 'web-ui-components/lib/global/layout';
import { BackButton } from 'web-ui-components/lib/molecules/navigation';
import withContent from '../../../containers/withContent';
import DeleteConfirmationModal from '../../../sharedComponents/DeleteConfirmationModal';
import pageContent, { contentPropTypes } from './index.content';
import { Table } from '../../../sharedComponents';
import { payeePropTypes } from '../../states/propTypes';
import { getSelectedPayee, getSourceAccountId } from '../../states/selectors';
import { goBackPage, setBackPage } from '../../../states/page/actions';
import { submitDeletePayee } from '../../states/action';
import { goToEditPayeePage } from '../../../states/api/fasterPaymentActions';
import { getPage } from '../../../states/page/selectors';
import { clearNotification } from '../../../../src/states/notifications/actions';
import { getAllNotifications } from '../../../../src/states/notifications/selectors';
import { hasApiCallInProgress } from '../../../states/api/selectors';
import { PageHeading, SubHeading } from 'web-ui-components/lib/typography/headings';
import { NavigationButton, NavigationButtonGroup } from 'web-ui-components/lib/navigation/buttons';

const mapState = (state) => ({
	newPayeeDetails: getSelectedPayee(state),
	currentPage: getPage(state),
	sourceAccountId: getSourceAccountId(state),
	notification: getAllNotifications(state),
	hasApiCallInProgress: hasApiCallInProgress(state),
});

const mapDispatch = (dispatch) => ({
	goBackPage: () => dispatch(goBackPage()),
	goToEditPayeePage: () => dispatch(goToEditPayeePage()),
	setBackPage: (currentPage) => dispatch(setBackPage(currentPage)),
	clearNotification: (id) => dispatch(clearNotification(id)),
	submitDeletePayee: (details) => dispatch(submitDeletePayee(details)),
});

export class ViewPayee extends Component {
	constructor(props) {
		super(props);
		this.state = {
			isModalOpen: false,
		};
		this.handleEditPayee = this.handleEditPayee.bind(this);
		this.handleDeletePayee = this.handleDeletePayee.bind(this);
		this.confirmDeletePayee = this.confirmDeletePayee.bind(this);
	}

	handleDeletePayee() {
		const { notification = [], clearNotification } = this.props;
		const notificationId = notification[0] && notification[0].id;
		clearNotification(notificationId);
		this.setState({
			isModalOpen: true,
		});
	}

	confirmDeletePayee() {
		const {
			sourceAccountId,
			submitDeletePayee,
			content: { deletePayeeSuccessMessage },
		} = this.props;
		const closeDeleteConfirmationModal = () => this.setState({ isModalOpen: false });

		submitDeletePayee({
			sourceAccountId,
			deletePayeeSuccessMessage,
			closeDeleteConfirmationModal,
		});
	}

	handleEditPayee() {
		const { goToEditPayeePage, currentPage, setBackPage } = this.props;
		setBackPage(currentPage);
		goToEditPayeePage();
	}

	render() {
		const {
			newPayeeDetails,
			goBackPage,
			content,
			content: { header, viewPayeeHeader, backButton, editPayeeButton, deletePayeeButton },
			hasApiCallInProgress,
			handleRoute,
		} = this.props;

		const { isModalOpen } = this.state;

		const primaryNavigationButtons = [
			<NavigationButton.Primary
				data-test-id="navigation--handle-edit-payee"
				onClick={this.handleEditPayee}
				labelText={editPayeeButton}
			/>,
			<NavigationButton.Primary
				data-test-id="navigation-handle-delete-payee"
				onClick={this.handleDeletePayee}
				labelText={deletePayeeButton}
			/>,
		];

		const secondaryNavigationButton = (
			<NavigationButton.Secondary
				data-test-id="navigation-handle-go-back"
				onClick={goBackPage}
				labelText={backButton}
			/>
		);

		return (
			<ServicingSection>
				<BackButton onClick={goBackPage} disabled={hasApiCallInProgress} />
				<PageHeading>{header}</PageHeading>
				<SubHeading>{viewPayeeHeader}</SubHeading>
				<Table content={content} newPayeeDetails={newPayeeDetails} />
				<div className="u-margin-top-4">
					<NavigationButtonGroup
						primaryButton={primaryNavigationButtons}
						secondaryButtons={secondaryNavigationButton}
					/>
				</div>

				<DeleteConfirmationModal
					confirmDeletePayee={this.confirmDeletePayee}
					handleClose={() => {
						this.setState({ isModalOpen: false });
					}}
					isModalOpen={isModalOpen}
					handleRoute={handleRoute}
					hasApiCallInProgress={hasApiCallInProgress}
				/>
			</ServicingSection>
		);
	}
}

ViewPayee.propTypes = {
	content: PropTypes.shape(contentPropTypes).isRequired,
	newPayeeDetails: PropTypes.shape(payeePropTypes).isRequired,
	goBackPage: PropTypes.func.isRequired,
	goToEditPayeePage: PropTypes.func.isRequired,
	currentPage: PropTypes.string.isRequired,
	setBackPage: PropTypes.func.isRequired,
	clearNotification: PropTypes.func.isRequired,
	notification: PropTypes.arrayOf(PropTypes.string.isRequired),
	submitDeletePayee: PropTypes.func.isRequired,
	sourceAccountId: PropTypes.string.isRequired,
	hasApiCallInProgress: PropTypes.bool.isRequired,
	handleRoute: PropTypes.func.isRequired,
};

export default compose(connect(mapState, mapDispatch), withContent({ content: pageContent }))(ViewPayee);
